// extracted by mini-css-extract-plugin
export default {"heading":"SceneGroupCreate_heading__E0yyo","delete":"SceneGroupCreate_delete__jppOZ","save-btn":"SceneGroupCreate_save-btn__HUZYN"};